import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard, Loader2 } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { useFont } from '../contexts/FontContext';

export default function AuthSuccess() {
  const { theme } = useTheme();
  const { font } = useFont();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  const urlParams = new URLSearchParams(window.location.search);
  const hasStripeParams =
    urlParams.has('session_id') ||
    urlParams.has('payment_intent') ||
    urlParams.has('stripe') ||
    urlParams.has('subscription');

  const isStripeSuccess =
    urlParams.has('session_id') ||
    urlParams.has('payment_intent') ||
    urlParams.has('stripe');

  const isSubscriptionSuccess =
    urlParams.get('subscription') === 'success';

  useEffect(() => {
    if (isSubscriptionSuccess) {
      // Stripe abonnement validé → lancer le countdown
      const countdownInterval = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(countdownInterval);
    } else {
      // Google auth ou autre → fermer immédiatement
      if (window.opener) {
        window.opener.postMessage('success', '*');
        window.close();
      } else {
        window.location.reload();
      }
    }
  }, [isSubscriptionSuccess]);

  if (!hasStripeParams) {
    return null;
  }

  return (
    <div
      className="min-h-screen bg-gray-50 flex items-center justify-center"
      style={{ fontFamily: font.family }}
    >
      <div className="max-w-md w-full mx-auto px-4">
        <div className="bg-white rounded-xl shadow-sm p-8 text-center">
          <div
            className={`inline-flex items-center justify-center w-16 h-16 rounded-full bg-${theme.secondary} mb-6`}
          >
            <CreditCard className={`h-8 w-8 text-${theme.text}`} />
          </div>

          <h1 className="text-2xl font-bold mb-4">
            Finalisation du paiement...
          </h1>
          <p className="text-gray-600 mb-8">
            Nous finalisons votre abonnement, veuillez patienter.
          </p>

          {isSubscriptionSuccess && (
            <>
              <div className="mb-6">
                <div className="text-6xl font-bold text-rose-500 mb-2">
                  {countdown}
                </div>
                <p className="text-sm text-gray-500">
                  Redirection automatique dans {countdown} seconde
                  {countdown > 1 ? 's' : ''}
                </p>
              </div>

              <div className="flex items-center justify-center">
                <Loader2 className="h-5 w-5 animate-spin text-gray-400 mr-2" />
                <span className="text-sm text-gray-500">
                  Traitement en cours...
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
